import { v4 as uuidv4 } from "uuid";

const FALLBACK_DEVICE_ID_KEY = "careem_fallback_device_id";
let cachedDeviceId = null;

export async function initDeviceId() {
  if (cachedDeviceId) {
    return cachedDeviceId;
  }

  const DeviceSdk = window.DeviceSdk;
  if (DeviceSdk !== undefined) {
    try {
      const deviceSdk = new DeviceSdk({
        token: `${process.env.REACT_APP_DEVICE_MANAGEMENT_TOKEN}`,
        baseUrl: `${process.env.REACT_APP_IDENTITY_SERVICES_SAG_HOST}`,
      });
      const deviceId = await deviceSdk.getDeviceId();
      if (deviceId) {
        cachedDeviceId = deviceId;
        if (window.dtrum && typeof window.dtrum.identifyUser === "function") {
          try {
            window.dtrum.identifyUser(deviceId);
          } catch (e) {
            // eslint-disable-next-line no-console
            console.error("dtrum.identifyUser failed:", e);
          }
        }
        return cachedDeviceId;
      }
    } catch (e) {
      // fall through to UUID fallback
    }
  }

  let fallbackId = localStorage.getItem(FALLBACK_DEVICE_ID_KEY);
  if (!fallbackId) {
    fallbackId = uuidv4();
    localStorage.setItem(FALLBACK_DEVICE_ID_KEY, fallbackId);
  }
  cachedDeviceId = fallbackId;
  return cachedDeviceId;
}

export function initProfiling() {
  const DeviceSdk = window.DeviceSdk;
  if (DeviceSdk === undefined) {
    return Promise.reject();
  }
  const deviceSdk = new DeviceSdk({
    token: `${process.env.REACT_APP_DEVICE_MANAGEMENT_TOKEN}`,
    baseUrl: `${process.env.REACT_APP_IDENTITY_SERVICES_SAG_HOST}`,
  });
  return deviceSdk.collectProfiling();
}

export function _resetDeviceIdCache() {
  cachedDeviceId = null;
}
